import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  BaseRouteReuseStrategy,
} from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class CustomRouteReuseStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot
  ): boolean {
    const futureReuseKey = future.data?.['reuseKey'];
    const currReuseKey = curr.data?.['reuseKey'];
    if (futureReuseKey && currReuseKey && futureReuseKey === currReuseKey) {
      return future.params['id'] === curr.params['id'];
    }

    if (future.routeConfig === curr.routeConfig) {
      return !future.params['id'] || future.params['id'] === curr.params['id'];
    }

    if (
      future.component &&
      curr.component &&
      future.component === curr.component
    ) {
      return future.params['id'] === curr.params['id'];
    }

    return false;
  }
}
